module.exports = __webpack_public_path__ + "img/accesibility.1bc871df.png";